import { createContext } from 'react';

import type { TextSize } from '../../core/types/text-size.js';
import { HONEYCOMB_VALUE_LABEL_FONT_SIZE } from '../constants.js';

export const HoneycombTextSizeContext = createContext<TextSize>(
  HONEYCOMB_VALUE_LABEL_FONT_SIZE,
);
